<template>
  <a-card>
    <a-table :columns="columns" :pagination="pagination" :data-source="dataSource" :loading="loading"
      @change="onTableChange">
      <template #titleName="{ record }">
        <a @click="onDetail(record)">
        <span style="color: green" v-if="record.titleName.includes('审核通过') > 0||record.titleName.includes('初审通过') > 0||record.titleName.includes('复审通过') > 0">{{record.titleName }}</span>
        <span style="color: red;" v-else>{{record.titleName }}</span>

      </a>
      </template>
      <template #states="{ text }">
        <span>{{ text == 0 ? '未读' : '已读' }}</span>
      </template>
    </a-table>
  </a-card>
  <DetailModal ref="detailModal" :form-primary-key-field="listKeyField" @onCloseModel="refresh" />
</template>

<script>
import DetailModal from './components/DetailModal';
import { tableListMixin } from "@/mixins";
import { sys_messageList } from "@/api/adminService";

const columns = [
  { title: "标题", dataIndex: "titleName", key: "titleName", slots: { customRender: "titleName" } },
  { title: "时间", dataIndex: "createdTime", key: "createdTime" },
  { title: '状态', dataIndex: 'states', key: 'states', slots: { customRender: 'states' } }
];
export default {
  name: "index",
  mixins: [tableListMixin],
  components: { DetailModal },
  data() {
    return {
      columns,
      queryParam: {},
      listUrl: sys_messageList.pageList,
      listKeyField: "id",
    }
  },
  methods: {
    onDetail(record) {
      this.getAction({
        url: sys_messageList.detail,
        params: { id: record.id }
      }).then(res => {
        this.onShowModal('detailModal', res)
      })
    },
    refresh() {
      this.loadData();
    }
  }
}
</script>

<style scoped></style>
